import axios from "axios";
import { authHeaderJson } from "../auth-header.service";


const getAllProjects = () => {
    return axios.get(`/api/contract/project`, { headers: authHeaderJson() } );
};

const getProjectById = (projectId) => {
    return axios.get(`/api/contract/project/${projectId}`, { headers: authHeaderJson() } );
};


const addProject = (project) => {
    return axios.post(`/api/contract/project/add/`, project, { headers: authHeaderJson() } );
}
const addProjectList = (projects) => {
    return axios.post(`/api/contract/project/add/list`, projects, { headers: authHeaderJson() } );
}
const saveProjectById = (projectId, objProject) => {
    return axios.put(`/api/contract/project/update/${projectId}`, objProject, { headers: authHeaderJson() });
};
const deleteProject = (projectId) => {
    return axios.delete(`/api/contract/project/delete/${projectId}`, { headers: authHeaderJson() });
}
export {
    addProject,
    addProjectList,
    saveProjectById,
    deleteProject,
    getAllProjects,
    getProjectById
}